export class GetUserInput {
    email: string = '';
    password: string = '';
}